import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Radio, Form } from 'antd';
import { useToggle } from '@/hooks';
import AlertBox from '../alert-box';

export default function RadioAlert({
  name,
  label,
  disabled = false,
  options,
  variant = 'question',
  alertText = 'This is for message!',
}) {
  const { open, onToggle, onClose } = useToggle(false);

  const handleToggle = () => {
    onToggle(!open);
  };

  return (
    <div className="relative">
      <AlertBox
        closable
        open={open}
        className="relative"
        variant={variant}
        onClose={onClose}
      >
        {alertText}
      </AlertBox>

      <div className="relative">
        <div className="absolute right-0 top-0">
          <Button
            type="default"
            className="btn-default z-[1] flex h-max items-center p-0"
            onClick={handleToggle}
          >
            <InfoCircleOutlined className="text-lg text-zinc-400" />
            <span className="sr-only">Info</span>
          </Button>
        </div>

        <Form.Item name={name} label={label} className="!mb-5">
          <Radio.Group
            className="custom-ant-radio-label custom-ant-radio-group"
            options={options}
            disabled={disabled}
          />
        </Form.Item>
      </div>
    </div>
  );
}
